<template>
    <div>
        <img class="user-poster" src="../assets/banner.jpg">
        <van-cell-group>
            <van-field
                    v-model="username"
                    required
                    clearable
                    label="用户名"
                    right-icon="question-o"
                    placeholder="请输入用户名"
                    @click-right-icon="$toast('用户编号')"
            />

            <van-field
                    v-model="password"
                    type="password"
                    label="密码"
                    placeholder="请输入密码"
                    required
            />
            <van-button type="primary" size="large" @click="login">登录</van-button>
        </van-cell-group>
    </div>
</template>

<script>
  import { login, getWhchatAuthUrl, wlogin } from '@/api/auth'
  import { Field, Button, Toast, Cell, CellGroup } from 'vant'
  import Cookies from 'js-cookie'

  export default {
    components: {
      [Field.name]: Field,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Button.name]: Button
    },
    data () {
      return {
        username: '', // 员工编号
        password: '',
        openid_key: ''
      }
    },
    methods: {
      login () {
        let data = {username: this.username, password: this.password}
        login(data).then((res) => {
          Toast(res.message)
          if (res.code === 200) {
            this.$router.push({path: '/'})
          }
        })
      }
    },
    mounted () {
      Cookies.remove('token')
      // this.$store.dispatch('user/resetToken').then(() => {
      //
      // })
      if(!this.$route.query.nothing) {
        if(this.$route.query.code){
          wlogin({code:this.$route.query.code}).then((res)=>{
            if(res.data.status == 1){
              this.$router.push({path: '/'})
            }
            if(res.data.status == 2){
              this.openid_key = res.data.key
            }
          })
        }else{
          getWhchatAuthUrl().then((res) => {
            if(res.data){
              location.href = res.data
            }
          })
        }
      }
    }
  }
</script>
<style lang="less">
    .red {
        color: red;
    }
    .green {
        color: green;
    }
    .user {
    &-poster {
         width: 100%;
         height: 53vw;
         display: block;
     }
    &-group {
         margin-bottom: 15px;
     }
    &-links {
         padding: 15px 0;
         font-size: 12px;
         text-align: center;
         background-color: #fff;
    .van-icon {
        display: block;
        font-size: 24px;
    }
    }
    }
</style>
